import { useEffect } from "react"
import { useSearchParams, Navigate, Outlet } from "react-router-dom"

import useLoginCookie from "shared/model/useLoginCookie"

// 로그인 Cookie가 존재한다면 메인 페이지로 Redirect
export const PublicRoute = () => {
    const [loginCookie] = useLoginCookie()

    return loginCookie
        ? <Navigate to="/" replace />
        : <Outlet />
}

// 로그인 Cookie가 존재하지 않는다면 로그인 페이지로 Redirect
export const PrivateRoute = () => {
    const [loginCookie] = useLoginCookie()

    return loginCookie
        ? <Outlet />
        : <Navigate to="/login" replace />
}

// page 값이 없다면 page query를 붙여 redirect
export const InitPageQueryRouter = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const pageIndex = parseInt(searchParams.get("page"))

    useEffect(() => {
        if (!pageIndex) {
            searchParams.set("page", "1")
            setSearchParams(searchParams, { "replace": true })
        }
    }, [pageIndex])

    return pageIndex
        ? <Outlet />
        : null
}